import React from 'react';
import { useQuery } from '@apollo/client';

import CollapsibleCardView from '../common/CardView/CollapsibleCardView';

import { FETCH_MODEL_ASSOC_PIPELINES } from '../../utils/model_server';

import ModelAssociationTimeline from './ModelAssociationTimeline';

export const ModelAssocPipelines = ({ id }) => {
  // This isn't likely to need to be shared, but if it is, move it to the ModelDataContext.
  const modelAssocPipelinesQueryRes = useQuery(FETCH_MODEL_ASSOC_PIPELINES, {
    variables: { id },
    pollInterval: 1000,
    // pollInterval: modelDetailTimeRangePollInterval,
  });

  if (!id) return <CollapsibleCardView>
    No data
  </CollapsibleCardView>;

  const formattedAssociations = modelAssocPipelinesQueryRes.data?.deployment_model_configs.map((modelAndPipeline) => {
    const { model_config: { model: { model_id, model_version } }, pipeline_version: { version, updated_at, pipeline: { pipeline_id } } } = modelAndPipeline;
    return {
      model_id,
      model_version,
      pipeline_id,
      pipeline_version: version,
      updated_at,
    }
  }) || [];

  return <ModelAssociationTimeline
    modelAssociations={formattedAssociations}
    dataError={modelAssocPipelinesQueryRes.error}
    dataLoading={modelAssocPipelinesQueryRes.loading}
    disableScrollFading
  />
};

export default ModelAssocPipelines;
